var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.button ? 'AppButton' : 'span',{tag:"component",class:[
    {'btn-show-loader': _vm.loading},
    _vm.button ? ('btn btn-block ' + (_vm.button === 'transparent' ? 'AppButton--transparent' : `btn-${_vm.button}`)) : '',
  ],on:{"click":_vm.logout},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[(_vm.icon)?_c('svgicon',{class:_vm.iconClasses,attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('LogoutButton.text'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }